if (!customElements.get('fbt-bundle')) {
  customElements.define(
    'fbt-bundle',
    class FbtBundle extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      connectedCallback() {
        this.cartSubtotal = 0;
        try { this.tiers = JSON.parse(this.dataset.tiers || '[]'); } catch (e) { this.tiers = []; }
        fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => { this.cartSubtotal = cart.items_subtotal_price || 0; if (this.rows) this.update(); })
          .catch(() => {});
        if (this.dataset.source === 'recommendations' && !this.querySelector('.fbt__box')) {
          this.load();
        } else {
          this.init();
        }
      }

      load(url = this.dataset.url) {
        fetch(url)
          .then((r) => r.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const fresh = html.querySelector('fbt-bundle');
            if (fresh && fresh.querySelector('.fbt__box')) {
              this.innerHTML = fresh.innerHTML;
              this.init();
            } else if (url.includes('intent=complementary')) {
              // No complementary products configured in Search & Discovery: fall back to related.
              this.load(url.replace('intent=complementary', 'intent=related'));
            } else {
              this.closest('.shopify-section')?.classList.add('hidden');
            }
          })
          .catch((e) => console.error(e));
      }

      init() {
        this.rows = [...this.querySelectorAll('[data-fbt-row]')];
        if (!this.rows.length) return;
        this.total = this.querySelector('[data-fbt-total]');
        this.compare = this.querySelector('[data-fbt-compare]');
        this.addBtn = this.querySelector('[data-fbt-add]');
        this.error = this.querySelector('[data-fbt-error]');
        this.rows.forEach((row) => {
          row.querySelector('[data-fbt-check]').addEventListener('change', () => this.update());
          const sel = row.querySelector('select[data-fbt-variant]');
          if (sel) sel.addEventListener('change', () => this.update());
        });
        this.addBtn.addEventListener('click', () => this.addToCart());
        this.update();
      }

      variantOf(row) {
        const el = row.querySelector('[data-fbt-variant]');
        if (el.tagName === 'SELECT') return el.options[el.selectedIndex];
        return el;
      }

      update() {
        let total = 0, compare = 0, selected = 0;
        this.rows.forEach((row) => {
          const on = row.querySelector('[data-fbt-check]').checked;
          const v = this.variantOf(row);
          const price = parseInt(v.dataset.price, 10) || 0;
          const cmp = parseInt(v.dataset.compare, 10) || 0;
          row.classList.toggle('is-off', !on);
          const thumb = this.querySelector(`[data-fbt-thumb="${row.dataset.productId}"]`);
          if (thumb) thumb.classList.toggle('is-off', !on);
          const rp = row.querySelector('[data-fbt-row-price]');
          const rc = row.querySelector('[data-fbt-row-compare]');
          if (rp) rp.textContent = this.money(price);
          if (rc) { rc.textContent = this.money(cmp); rc.hidden = !(cmp > price); }
          if (on) { selected++; total += price; compare += cmp > price ? cmp : price; }
        });
        this.total.textContent = this.money(total);
        this.compare.textContent = this.money(compare);
        this.compare.hidden = !(compare > total);
        const save = this.querySelector('[data-fbt-save]');
        if (save) {
          const extraWrap = save.querySelector('[data-fbt-save-extra]');
          const projected = total + (this.cartSubtotal || 0);
          const reached = this.tiers.filter((tier) => projected >= tier.min).pop();
          const nextTier = this.tiers.find((tier) => projected < tier.min && tier.off > 0);
          const hasExtra = reached && (reached.off > 0 || reached.label);
          save.hidden = !(compare > total) && !hasExtra;
          save.querySelector('[data-fbt-save-amount]').textContent = this.money(compare - total);
          save.querySelector('[data-fbt-save-amount]').hidden = !(compare > total);
          if (extraWrap) {
            extraWrap.hidden = !hasExtra;
            if (hasExtra) extraWrap.querySelector('[data-fbt-save-extra-label]').textContent = reached.label;
          }
          const nudge = this.querySelector('[data-fbt-nudge]');
          if (nudge) {
            nudge.hidden = !nextTier || selected === 0;
            if (nextTier) nudge.textContent = `Add ${this.money(nextTier.min - projected)} more for ${nextTier.label}`;
          }
        }
        this.addBtn.disabled = selected === 0;
      }

      money(cents) {
        const fmt = this.dataset.moneyFormat || '{{amount}}';
        const amount = cents / 100;
        const withDecimals = amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const noDecimals = Math.round(amount).toLocaleString('en-IN');
        return fmt
          .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace(/,/g, ' ').replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals.replace(/,/g, '.'))
          .replace(/<[^>]*>/g, '');
      }

      addToCart() {
        const items = this.rows
          .filter((row) => row.querySelector('[data-fbt-check]').checked)
          .map((row) => ({ id: parseInt(this.variantOf(row).value, 10), quantity: 1 }));
        if (!items.length) return;

        this.error.hidden = true;
        this.addBtn.setAttribute('aria-disabled', 'true');
        this.addBtn.classList.add('loading');

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then((response) => {
            if (response.status) {
              this.error.textContent = response.description || response.message;
              this.error.hidden = false;
              return;
            }
            if (!this.cart) { window.location = window.routes.cart_url; return; }
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: items[0].id, cartData: response });
            }
            this.cart.renderContents(response);
            fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => { this.cartSubtotal = cart.items_subtotal_price || 0; this.update(); }).catch(() => {});
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.addBtn.classList.remove('loading');
            this.addBtn.removeAttribute('aria-disabled');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }
    }
  );
}
